'use client'

import { useEffect } from 'react'
import { dispatch } from '@/lib/store'
import { updatePackageData } from '@/lib/reducers/packageReducer'

interface SharedCatalogHydratorProps {
  carePackageList?: any[] | null
  diseaseCategoryDtoList?: any[] | null
}

// Seeds Redux from SSR so NavSubmenu has data without an extra client call; only non-empty keys are dispatched so it never clobbers fresher data.
const SharedCatalogHydrator = ({
  carePackageList,
  diseaseCategoryDtoList,
}: SharedCatalogHydratorProps) => {
  useEffect(() => {
    const payload: Record<string, any> = {}
    if (carePackageList?.length) payload.carePackageList = carePackageList
    if (diseaseCategoryDtoList?.length)
      payload.diseaseCategoryDtoList = diseaseCategoryDtoList
    if (Object.keys(payload).length) {
      dispatch(updatePackageData(payload))
    }
  }, [])

  return null
}

export default SharedCatalogHydrator
